import type { ContractorTranslation } from './en';

export const ar: ContractorTranslation = {
  common: {
    cancel: 'إلغاء',
    save: 'حفظ',
    retry: 'إعادة المحاولة',
    download: 'تنزيل',
    continue: 'متابعة',
    yes: 'نعم',
    no: 'لا',
    genericError: 'حدث خطأ ما. يُرجى المحاولة مرة أخرى.',
    networkError: 'تعذّر الاتصال بـ DubForge. تحقّق من اتصالك بالإنترنت.',
  },
  app: {
    tagline: 'مهام الدبلجة والملفات والمراجعات في مكان واحد.',
    startupFailed: 'تعذّر تشغيل DubForge',
    notFoundTitle: 'الصفحة غير موجودة',
    notFoundBody: 'هذه الصفحة غير موجودة أو ليست لديك صلاحية الوصول إليها.',
    goHome: 'العودة إلى الصفحة الرئيسية',
    crashTitle: 'حدث خطأ ما',
    crashBody: 'حاول إعادة تحميل الصفحة.',
    reload: 'إعادة التحميل',
  },
  language: {
    label: 'اللغة',
    change: 'تغيير اللغة',
  },
  welcome: {
    title: 'مرحبًا بك في DubForge',
    body: 'اختر لغتك. سيستخدمها DubForge وإشعارات Discord الخاصة بك.',
    changeLater: 'يمكنك تغييرها في أي وقت من قائمة اللغة أعلى الصفحة.',
  },
  nav: {
    myAssignments: 'مهامي',
    openMenu: 'فتح القائمة',
    account: 'الحساب',
    notificationEmail: 'بريد الإشعارات',
    signOut: 'تسجيل الخروج',
    roleAdmin: 'المسؤول',
    roleContractor: 'مؤدٍّ صوتي',
    lightMode: 'الوضع الفاتح',
    darkMode: 'الوضع الداكن',
  },
  login: {
    signIn: 'تسجيل الدخول باستخدام Discord',
    onlyInvited: 'لا يمكن تسجيل الدخول إلا لحسابات Discord التي أضافها مالك القناة.',
    signingIn: 'جارٍ تسجيل الدخول…',
    backToSignIn: 'العودة إلى تسجيل الدخول',
    failed: 'تعذّر تسجيل الدخول. يُرجى المحاولة مرة أخرى.',
  },
  authErrors: {
    not_invited: 'لم تتم إضافة حساب Discord هذا إلى DubForge. اطلب من مالك القناة إضافتك.',
    access_off: 'تم إيقاف وصولك إلى DubForge.',
    discord_only: 'يمكنك تسجيل الدخول باستخدام Discord فقط.',
  },
  errors: {
    not_signed_in: 'انتهت جلستك. يُرجى تسجيل الدخول مرة أخرى.',
    access_off: 'تم إيقاف وصولك إلى DubForge.',
    admins_only: 'ليست لديك صلاحية للقيام بذلك.',
    not_found: 'هذا العنصر غير موجود أو لم يعد متاحًا.',
    invalid_request: 'يوجد خطأ في هذا الطلب. يُرجى التحقق والمحاولة مرة أخرى.',
    conflict: 'هذا العنصر موجود بالفعل.',
    already_approved: 'تمت الموافقة على هذه المهمة بالفعل، لذلك لا حاجة إلى رفع المزيد.',
    not_audio: 'لا يمكن رفع سوى ملفات WAV أو MP3. ارفع مسار صوتك فقط.',
    upload_incomplete: 'لم يكتمل الرفع. يُرجى المحاولة مرة أخرى.',
    discord_unreachable: 'تعذّر الاتصال بـ Discord. يُرجى المحاولة لاحقًا.',
    server_error: 'حدث خطأ من جهتنا. يُرجى المحاولة مرة أخرى.',
  },
  notifications: {
    title: 'الإشعارات',
    openWithCount: 'الإشعارات (غير المقروءة: {{count}})',
    markAllRead: 'تحديد الكل كمقروء',
    empty: 'لا يوجد شيء بعد.',
  },
  emailSettings: {
    body: 'نرسل إليك بريدًا إلكترونيًا عندما تتلقى مهمة جديدة وعند مراجعة عملك.',
    label: 'عنوان البريد الإلكتروني',
    fromDiscord: 'مأخوذ من حساب Discord الخاص بك. غيّره إذا كنت تفضّل عنوانًا آخر.',
    saved: 'تم حفظ عنوان البريد الإلكتروني',
    invalid: 'أدخل عنوان بريد إلكتروني صالحًا.',
    missing: 'لا يوجد عنوان بريد إلكتروني بعد. أضف عنوانًا لتلقي الإشعارات.',
  },
  status: {
    Assigned: 'مُسندة',
    InProgress: 'قيد التنفيذ',
    Submitted: 'بانتظار المراجعة',
    ChangesRequested: 'مطلوب تعديلات',
    Approved: 'تمت الموافقة',
  },
  assetKind: {
    package: 'حزمة الدبلجة (فيديو + صوت + مؤثرات صوتية)',
    video: 'فيديو مرجعي (720p)',
    sfx: 'مسار المؤثرات الصوتية / الموسيقى',
    voice: 'مسار الصوت الأصلي',
    script: 'النص',
    other: 'أخرى',
  },
  translation: {
    machine: 'ترجمة آلية',
    showOriginal: 'عرض النص الأصلي',
    showTranslation: 'عرض الترجمة',
  },
  uploader: {
    progress: '{{percent}}% من {{size}}',
    queued: 'بانتظار الرفع: {{count}}',
    keepOpen: 'أبقِ علامة التبويب هذه مفتوحة حتى ينتهي الرفع.',
    cancelled: 'تم إلغاء الرفع',
    done: 'تم رفع {{name}}',
    failed: 'فشل الرفع: {{error}}',
  },
  my: {
    greeting: 'مرحبًا {{name}}',
    subtitle: 'مهام الدبلجة الخاصة بك.',
    emptyTitle: 'لا توجد مهام بعد',
    emptyBody: 'عندما يُسنَد إليك فيديو، ستصلك رسالة على Discord وستظهر المهمة هنا.',
    todo: 'للتنفيذ',
    waiting: 'بانتظار المراجعة',
    done: 'مكتملة',
    updated: 'آخر تحديث {{when}}',
  },
  assignment: {
    back: 'مهامي',
    dubIn: 'الدبلجة: {{language}}',
    paid: 'مدفوع',
    next: {
      Assigned: 'نزّل ملفات المصدر، وسجّل صوتك، ثم ارفع مسار صوتك هنا.',
      InProgress: 'عندما يصبح مسار صوتك جاهزًا، ارفعه أدناه.',
      Submitted: 'تم إرسال دبلجتك للمراجعة. ستصلك رسالة على Discord عند مراجعتها.',
      ChangesRequested: 'طُلبت تعديلات. اقرأ الملاحظات أدناه، ثم ارفع نسخة جديدة.',
      Approved: 'تمت الموافقة. شكرًا لك!',
    },
    notes: 'ملاحظات',
    sourceFiles: 'ملفات المصدر',
    noFiles: 'لم يتم رفع أي ملفات بعد.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'ملف ‎.mp4 واحد يضم الفيديو ومسارين صوتيين: المسار 1 هو الحوارات الأصلية، والمسار 2 هو المؤثرات الصوتية (SFX).',
    uploadTitle: 'ارفع مسار صوتك',
    voiceOnlyTitle: 'صوتك فقط',
    voiceOnlyBody:
      'ارفع صوتك المسجَّل فقط: بدون موسيقى، وبدون مؤثرات صوتية، وبدون أي جزء من الصوت الأصلي. تأكّد من أن مدته مطابقة لمدة الأصل.',
    voiceOnlyConfirm: 'يحتوي هذا الملف على الحوارات الصوتية فقط.',
    dropLabel: 'ارفع مسار الصوت هنا',
    dropHint: 'WAV أو MP3 فقط.',
    noteForReviewer: 'ملاحظة للمراجع (اختيارية)',
    lengthTitle: 'المدة غير متطابقة',
    lengthBody:
      'مدة ملفك {{dub}}، بينما مدة مسار المؤثرات الصوتية {{sfx}}. إذا كان مسارك يبدأ من نقطة مختلفة أو كان مقطوعًا، فلن يتطابق مع الفيديو. هل تريد رفعه على أي حال؟',
    uploadAnyway: 'الرفع على أي حال',
    chooseAnother: 'اختيار ملف آخر',
    versions: 'النسخ المرفوعة',
    nothingUploaded: 'لم يتم رفع أي شيء بعد.',
    version: 'النسخة {{version}}',
    reviewApproved: 'تمت الموافقة',
    reviewChanges: 'مطلوب تعديلات',
    reviewPending: 'بانتظار المراجعة',
    yourNote: 'ملاحظتك:',
    feedback: 'الملاحظات',
    listen: 'استماع',
    uploadedOn: '{{date}} · {{size}}',
    length: 'المدة: {{duration}}',
  },
};
